<div
  class="wrapper flex-column"
  appDnd
  (fileDropped)="onFileDropped($event)"
  (hover)="hover($event)"
>
  <div *ngIf="questionnaireMode && submissionLoading" class="loading-container">
    <div class="spinner-y"></div>
    <div class="loading-text">Saving use-case...</div>
  </div>
  <app-project-preview-loading
    [show]="submissionLoading && !questionnaireMode"
    [text]="'The project is being created...'"
  ></app-project-preview-loading>

  <div *ngIf="!submissionLoading" class="input-wrap">
    <div
      *ngIf="!questionnaireMode"
      style="margin: 12px auto; text-align: center; font-size: 24px"
    >
      New project {{ newProjectName ? '-' + newProjectName : '' }}
    </div>
    <div class="card flex-column gap-16" (mouseover)="$event.stopPropagation()">
      <div class="submissions" *ngIf="addedPrompts.length">
        <h3 style="margin-left: 12px">Content</h3>
        <div class="submission" *ngFor="let p of addedPrompts; let i = index">
          <div class="content" *ngIf="p.text">{{ p.text }}</div>
          <div class="files thumbnails" *ngIf="p.media?.length">
            <ng-container *ngFor="let f of p.media; let j = index">
              <div
                class="thumb clickable"
                *ngIf="f.type === 'image'"
                (click)="onPromptFileClick(i, j, $event.target)"
              >
                <img [src]="f.url" alt="image" class="thumbnail" />
              </div>

              <div
                class="thumb clickable video"
                *ngIf="f.type === 'video'"
                (click)="onPromptFileClick(i, j, $event.target)"
              >
                <video [src]="f.url" muted playsinline></video>
                <div class="play-badge" aria-hidden="true">
                  <nw-icon type="play_arrow" [size]="12"></nw-icon>
                </div>
              </div>

              <div
                class="thumb clickable doc"
                *ngIf="f.type === 'doc'"
                (click)="onPromptFileClick(i, j, $event.target)"
              >
                <div class="doc-icon" [attr.data-type]="f.docType">
                  {{ f.docType?.toUpperCase() }}
                </div>
                <div class="filename" [title]="f.name || ''">{{ f.name }}</div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="prompt-input">
        <div class="flex-column gap-8 input-field">
          <textarea
            [(ngModel)]="pendingPrompt.text"
            rows="4"
            [placeholder]="textAreaPlaceHolder"
            (keyup)="keyup($event)"
          ></textarea>
          <div
            style="position: relative; pointer-events: none"
            *ngIf="imageUploadState === 'dragging'"
          >
            <div
              class="flex-row space-around"
              style="
                position: absolute;
                top: -96px;
                left: 0;
                width: 700px;
                height: 104px;
              "
            >
              <nw-icon type="upload" [outlined]="true" [size]="24"></nw-icon>
            </div>
          </div>

          <div class="thumbnails" *ngIf="pendingPrompt.media.length > 0">
            <div
              class="thumb clickable"
              *ngFor="let item of pendingPrompt.media; let i = index"
              (click)="openOverlay(i, $event.target)"
            >
              <button
                type="button"
                class="remove-btn"
                title="Remove"
                aria-label="Remove"
                (click)="removePendingFile(i, $event)"
              >
                ×
              </button>

              <img
                *ngIf="item.type === 'image'"
                [src]="item.url"
                alt="Thumbnail"
                class="thumbnail"
              />

              <div *ngIf="item.type === 'video'" class="thumb video">
                <video [src]="item.url" muted playsinline></video>
                <div class="play-badge" aria-hidden="true">
                  <nw-icon type="play_arrow" [size]="14"></nw-icon>
                </div>
              </div>

              <div *ngIf="item.type === 'doc'" class="thumb doc">
                <div class="doc-icon" [attr.data-type]="item.docType">
                  {{ item.docType?.toUpperCase() }}
                </div>
                <div class="filename" [title]="item.name || ''">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="error" *ngIf="errorMsg">{{ errorMsg }}</div>
          <input
            #docInput
            type="file"
            accept="
              image/*,
              video/*,
              .pdf,
              .ppt,
              .pptx,
              application/pdf,
              application/vnd.ms-powerpoint,
              application/vnd.openxmlformats-officedocument.presentationml.presentation
            "
            multiple
            hidden
            (change)="onFilesSelected($event)"
          />
          <!-- Hidden native file inputs for Image/Video/Doc pickers -->
          <!-- <input
            #imageInput
            type="file"
            accept="image/*"
            multiple
            hidden
            (change)="onFilesSelected('image', $event)"
          />
          <input
            #videoInput
            type="file"
            accept="video/*"
            multiple
            hidden
            (change)="onFilesSelected('video', $event)"
          />
          <input
            #docInput
            type="file"
            accept=".pdf,.ppt,.pptx,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
            multiple
            hidden
            (change)="onFilesSelected('doc', $event)"
          /> -->

          <div class="flex-row space-between fs-12 input-row">
            <div class="flex-row gap-8">
              <div class="icon-cont" (click)="triggerFileInput('doc')">
                <!-- type="image_arrow_up" -->
                <nw-icon type="upload" [size]="16" [outlined]="true"></nw-icon>
                <div>Video, image, file</div>
              </div>
              <!-- <div class="icon-cont">
                <nw-icon
                  type="video_camera_back_add"
                  [outlined]="true"
                  [size]="16"
                  (click)="triggerFileInput('video')"
                ></nw-icon>
                <div>Video</div>
              </div>
              <div class="icon-cont">
                <nw-icon
                  type="file_open"
                  [outlined]="true"
                  [size]="15"
                  (click)="triggerFileInput('doc')"
                ></nw-icon>
                <div>File</div>
              </div> -->
              <ng-container *ngIf="!questionnaireMode">
                <div class="icon-cont">
                  <nw-icon
                    [outlined]="true"
                    type="captive_portal"
                    [size]="16"
                    (click)="submitPrompt()"
                  ></nw-icon>
                  <div>Website</div>
                </div>
                <div
                  class="icon-cont"
                  [class.configured]="hasColors$ | async"
                  (click)="openColorEditor()"
                >
                  <nw-icon
                    [outlined]="true"
                    type="palette"
                    [size]="16"
                  ></nw-icon>
                  <div>Colors</div>
                </div>
              </ng-container>
            </div>

            <div
              class=""
              style="border: 1px solid black; padding: 4px; border-radius: 28px"
              [style.opacity]="
                questionnaireMode && !pendingPrompt.text?.trim() ? 0.4 : 1
              "
              [style.pointer-events]="
                questionnaireMode && !pendingPrompt.text?.trim()
                  ? 'none'
                  : 'auto'
              "
            >
              <nw-icon
                type="arrow_upward_alt"
                [size]="16"
                (click)="submitNewProject()"
              ></nw-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row" *ngIf="!questionnaireMode">
        <div
          class="generate-button flex-row gap-4"
          (click)="submitNewProject()"
        >
          <div>{{ questionnaireMode ? 'Submit' : 'Generate video' }}</div>
          <img
            *ngIf="!questionnaireMode"
            src="./assets/icons/ai_dark.svg"
            style="height: 16px"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Overlay media preview (outside wrapper to avoid overflow:hidden and transform issues) -->
<div
  class="overlay-backdrop"
  *ngIf="overlayOpen"
  role="dialog"
  aria-modal="true"
  cdkTrapFocus
  (click)="onBackdropClick($event)"
  (keydown)="onOverlayKeydown($event)"
  tabindex="-1"
>
  <button
    #overlayCloseBtn
    class="overlay-close"
    (click)="closeOverlay()"
    aria-label="Close preview"
  >
    ×
  </button>

  <button
    class="overlay-nav prev"
    *ngIf="overlayItems.length > 1"
    (click)="prev()"
    [disabled]="overlayIndex === 0"
    aria-label="Previous"
  >
    ‹
  </button>

  <div class="overlay-content">
    <ng-container *ngIf="currentItem as item">
      <img *ngIf="item.type === 'image'" [src]="item.url" alt="image preview" />
      <video
        *ngIf="item.type === 'video'"
        [src]="item.url"
        controls
        autoplay
        muted
        playsinline
        preload="metadata"
      ></video>
      <div
        *ngIf="item.type === 'doc'"
        class="doc-icon large"
        [attr.data-type]="item.docType"
        [attr.aria-label]="
          (item.docType || 'doc') +
          ' document' +
          (item.name ? ': ' + item.name : '')
        "
      ></div>
    </ng-container>
  </div>

  <button
    class="overlay-nav next"
    *ngIf="overlayItems.length > 1"
    (click)="next()"
    [disabled]="overlayIndex >= overlayItems.length - 1"
    aria-label="Next"
  >
    ›
  </button>
</div>
